import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import { Popover, PopoverContent, PopoverTrigger } from '@newfront-insurance/core-ui/v2';
import { useProvider } from '@newfront-insurance/react-provision';
import { useMemo, useState, type JSX } from 'react';
import { AppSwitcherMenu } from './components/app-switcher-menu';
import { LayoutConfigProvider } from '../../../../config';
import { AppType, canViewApp, getAppTypeMetadata, getAppTypes } from '../../../../metadata/apps';
import { ToolbarButton } from '../toolbar-button';
export function AppSwitcherButton() {
  const $ = _c(12);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const appTypes = useAppSwitcherItems();
  if (appTypes.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== isPopoverOpen) {
    t0 = () => setIsPopoverOpen(!isPopoverOpen);
    $[0] = isPopoverOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AppSwitcherIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isPopoverOpen || $[4] !== t0) {
    t2 = <PopoverTrigger><ToolbarButton tabIndex={0} title="Switch app" data-active={isPopoverOpen} onClick={t0}>{t1}</ToolbarButton></PopoverTrigger>;
    $[3] = isPopoverOpen;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== appTypes) {
    t3 = <PopoverContent className="flex w-full flex-col justify-center rounded-xs border-none p-0" align="end"><AppSwitcherMenu types={appTypes} /></PopoverContent>;
    $[6] = appTypes;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isPopoverOpen || $[9] !== t2 || $[10] !== t3) {
    t4 = <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>{t2}{t3}</Popover>;
    $[8] = isPopoverOpen;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function AppSwitcherIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M0 3.98671H3.84512V0H0V3.98671ZM5.76768 15.9468H9.61281V11.9601H5.76768V15.9468ZM0 15.9468H3.84512V11.9601H0V15.9468ZM0 9.96678H3.84512V5.98007H0V9.96678ZM5.76768 9.96678H9.61281V5.98007H5.76768V9.96678ZM11.5354 0V3.98671H15.3805V0H11.5354ZM5.76768 3.98671H9.61281V0H5.76768V3.98671ZM11.5354 9.96678H15.3805V5.98007H11.5354V9.96678ZM11.5354 15.9468H15.3805V11.9601H11.5354V15.9468Z" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function useAppSwitcherItems(): AppType[] {
  const {
    authProvider,
    currentApp
  } = useProvider(LayoutConfigProvider);
  const {
    userDetails: user
  } = useProvider(authProvider);
  const isCoverageGapAnalysisEnabled = useFeatureFlag('coverage-gap-analysis', false);

  // Get all of the app types and filter out the current app
  return useMemo(() => {
    return getAppTypes()
    // Don't show the current app
    .filter(type => type !== currentApp)

    // Filter app to ones set to show in menu
    .filter(type_0 => {
      const {
        showInMenu
      } = getAppTypeMetadata(type_0);
      return showInMenu;
    })

    // Filter the apps shown using the scopes on the user.
    .filter(type_1 => {
      if (!user) return false;
      if (type_1 === AppType.COVERAGE_GAP_ANALYSIS && !isCoverageGapAnalysisEnabled) return false;
      return canViewApp(type_1, user.roles);
    }).sort();
  }, [currentApp, user]);
}